<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
  {
    "num_cand": "U2FsdGVkX1/OwdDReFV9tE9jv+TpEZpAaNq9iiO8Uas=",
    "cpf": "U2FsdGVkX19wgh8OzJzD9V4Qi/0pHy5EC6S2ghV2C1Y="
  },
  {
    "num_cand": "U2FsdGVkX19yUhdIGJ9T96rwqNH50xQvOdZtJsH7ll8=",
    "cpf": "U2FsdGVkX1+6nP4z9BYdJM2ryY9q4YrIWm6xG8AlYOE="
  },
  {
    "num_cand": "U2FsdGVkX18tqoHVmA+B0SHNuWov/yz2wapdQLu1BQA=",
    "cpf": "U2FsdGVkX1+ulT7S102Cyc34Y8hG9EuG8bJLVT1X4Uo="
  },
  {
    "num_cand": "U2FsdGVkX189LKQcd9Oqwk1SaPSZ/7agwTYZUuUbXMU=",
    "cpf": "U2FsdGVkX1+3NEUmfov1a76YiaAadb0ymILfhlohgQ8="
  },
  {
    "num_cand": "U2FsdGVkX1+2NvWVa+lYNiCJlfFg5pbOdluH9GFqA+o=",
    "cpf": "U2FsdGVkX19cM1/rnbI+/FkMZ1tHaFZwfQ3yXVa2Qtk="
  },
  {
    "num_cand": "U2FsdGVkX18OiGY8CvXPZQb5uS2F9h9i+dbD1KeUjvY=",
    "cpf": "U2FsdGVkX18DWnc5uCl5gOg3uRGYIeOxTJHtqm+ZaM4="
  },
  {
    "num_cand": "U2FsdGVkX1/Qzu38jv5wWVrTLz6PBOFhM4AuvzFeujA=",
    "cpf": "U2FsdGVkX19Hi99A6uOK7GdGGhTflZFzgr0Y53NgedE="
  },
  {
    "num_cand": "U2FsdGVkX1/bqxECSC5EU/PRXECyxtpLtiZAMM4cxXY=",
    "cpf": "U2FsdGVkX1/KbCrbYL8+5tvjjBtk3QGpXhi39lfm0MA="
  },
  {
    "num_cand": "U2FsdGVkX1/Dp9O8GIq2sOZD4RlNjyF4tvugur9v77c=",
    "cpf": "U2FsdGVkX1+zkxcEGpE5pbWjsJ1Bd5DQd2wx9RYgOJc="
  },
  {
    "num_cand": "U2FsdGVkX18mZc9iXXw6tZMRrXcOSIQBWg+uXzDktSM=",
    "cpf": "U2FsdGVkX18N7oifTQ3ozsqwoUpGuQtijL+mmD6Q7F0="
  },
  {
    "num_cand": "U2FsdGVkX1+MRfcsW9ibbP+5RR6mDpRL8b2u4XrUQhE=",
    "cpf": "U2FsdGVkX1/ahHIExJlox0rqm6I4yqhsXqJ78Ef2/wk="
  },
  {
    "num_cand": "U2FsdGVkX19vFdaIeJ2ys///2eaHr+VPmfHSZqIQnqU=",
    "cpf": "U2FsdGVkX185uz+eL2jgIs41LZf7bhSN7iQmd4oFsnM="
  },
  {
    "num_cand": "U2FsdGVkX18ILqnNiGd0yPv+UluliO0QTklVT0LLxsI=",
    "cpf": "U2FsdGVkX19+s6pWnaBwccvfAG6hb/v8MfOrTStrlR8="
  },
  {
    "num_cand": "U2FsdGVkX195nwraVyIOJg57CTeRveEVr59FfgZxFQo=",
    "cpf": "U2FsdGVkX19/TYSifOqbMuKDxapgyRsBdGRPgWrDw+0="
  },
  {
    "num_cand": "U2FsdGVkX18hlNv32itNKvnknFKI6JNrF3dWCAq1VGU=",
    "cpf": "U2FsdGVkX1/qv5QoNeAbPKPVZ3jALASTvW9JbU90rA4="
  },
  {
    "num_cand": "U2FsdGVkX1/qHQyldL9D38etTfH37N0HRIOTgHwFsig=",
    "cpf": "U2FsdGVkX1/z8vfXA33bPHduHriI1UYVoT0cpaSL+i8="
  },
  {
    "num_cand": "U2FsdGVkX1+reRk0Zse9t5jJPY5Ikxu21SxvIRIPRsM=",
    "cpf": "U2FsdGVkX18WkePlrqTWuhB8zrV3kJZ4Akqxd8f+AXg="
  },
  {
    "num_cand": "U2FsdGVkX19R+4oLWXV0//ao++r+Ec9uMgKd8T4jDs4=",
    "cpf": "U2FsdGVkX197U7vqbnOJ3PKOx0UFaEkDOadqIvtucv0="
  },
  {
    "num_cand": "U2FsdGVkX19f7AJenFC4SM/HsYecK4mtj3wub1XXltA=",
    "cpf": "U2FsdGVkX1+oWk9uwwQBhj8cIs7bqseJbosHnwlaGH0="
  },
  {
    "num_cand": "U2FsdGVkX180oCR5NqUg740Wz6UfVFxX13VOwFMpwDI=",
    "cpf": "U2FsdGVkX1+zlODV3kzLZG7nesik5964a8lC0xApVCA="
  },
  {
    "num_cand": "U2FsdGVkX1+ErsQD6wJtILrY0n8V5MlarHI5Z60JTNc=",
    "cpf": "U2FsdGVkX1922iL8OnKRdau86ez9AGaXpiIEU4tsDGk="
  },
  {
    "num_cand": "U2FsdGVkX1+tB4cAUgC84WKtcZAUeegY6Y6KaBQrQGA=",
    "cpf": "U2FsdGVkX1+/chg/KQye82ZlytwCQ7ca4rk7cFHLe2I="
  },
  {
    "num_cand": "U2FsdGVkX190+SpKnH4GsWYFgXjj4t/Nx9ffNK6WEFw=",
    "cpf": "U2FsdGVkX1+NxCGJBERnHmYlZyWcui0bhjjc49nUESg="
  },
  {
    "num_cand": "U2FsdGVkX181DL+hsxhkF3qfGe7YoHjZqPW3BFG+NNM=",
    "cpf": "U2FsdGVkX1+kuhjS67BR162ruNw9+1Gfh/R3EUIIoFc="
  },
  {
    "num_cand": "U2FsdGVkX18jXD7P68cEZv+7KMoATRoEZGKTRAhyyi4=",
    "cpf": "U2FsdGVkX18DfxBo7n6ioyr6dIc5fAw4sRM1uLQa1YA="
  },
  {
    "num_cand": "U2FsdGVkX18dUPulPv4hdV0YXeWkM9MGWpOtSyRR/bM=",
    "cpf": "U2FsdGVkX191AQp7yuQ16762HN+F/B2gr29Ykt85JUc="
  },
  {
    "num_cand": "U2FsdGVkX18L9YfA6AE6AGqmgdQHZGnYN0bwYX7lcFA=",
    "cpf": "U2FsdGVkX18t6h7EAd+jXMmEgLpmKxId5KEsqgLQq1s="
  },
  {
    "num_cand": "U2FsdGVkX1+CWNj8jyE2rJysEz72FPmwFHhywoshkh0=",
    "cpf": "U2FsdGVkX18vrO+de0wckbQyyDcQx2ssxb3x8Ut3fZE="
  },
  {
    "num_cand": "U2FsdGVkX1+yNjqgUHHVnArzqxW0uDbA2IJaAK4kWTo=",
    "cpf": "U2FsdGVkX18vFTU1YiDP3b3j/HPROHJQI526CBH2ZL8="
  },
  {
    "num_cand": "U2FsdGVkX19MHyIBcm/2NC4m9TJBqWUHNploggTM72o=",
    "cpf": "U2FsdGVkX1/Xn8Qtu9irrphRNTWHTQuU+++IdWFVqTg="
  },
  {
    "num_cand": "U2FsdGVkX1/3BkXzn0pOc+9uigaxfJrIXoEg/76bRqQ=",
    "cpf": "U2FsdGVkX1+CyX3hYxkPq8k00lFI14g/7MPJejjUOjY="
  },
  {
    "num_cand": "U2FsdGVkX19fQfaFpYPIRboHBSo7unb3FWF0/izuJio=",
    "cpf": "U2FsdGVkX1+y2R1bAV6v8GLlUZnLUfOtQt4QqsHJYIM="
  },
  {
    "num_cand": "U2FsdGVkX1+f09m90CPj5Uuand5wHOYAqXgDez7qcCw=",
    "cpf": "U2FsdGVkX1/0erZrYnddyWB+FeZ+DvzRjPFjLaOGUgY="
  },
  {
    "num_cand": "U2FsdGVkX1/U7R7FYicERTUNGAuJwdNRf8tzPmBNl0s=",
    "cpf": "U2FsdGVkX1/2n48vZrFb+aeWzOAuE+ZAB6xL1yIw4uU="
  },
  {
    "num_cand": "U2FsdGVkX1/uZE4Kfvvbruf+QiLz8REwLFGQsPBY2nc=",
    "cpf": "U2FsdGVkX1+nyvIL8a7xq1ZSHHGiIzX3AzEImiar2oU="
  },
  {
    "num_cand": "U2FsdGVkX1+eUjbAD2KvdD03zEPCWSm8sbKKxoMu0Uo=",
    "cpf": "U2FsdGVkX19QB1m/Yfwj5rftJGGHb6Jr7CzZUiYlxkw="
  },
  {
    "num_cand": "U2FsdGVkX1/m60H7UozmP4pkflU+VBWeSn3hdTt7BLA=",
    "cpf": "U2FsdGVkX19cwdK5d+GpnWL390sCJO5uf2x+0Quqyxg="
  },
  {
    "num_cand": "U2FsdGVkX1980BC6f1hhb9LIrVaVeUwJnjqosTJ4oCI=",
    "cpf": "U2FsdGVkX1/BtZjT9S0jYTW6exPcbxo08xx5Mu4tH00="
  },
  {
    "num_cand": "U2FsdGVkX19HFQSCFuGrbd4mbP/2od1qJ/T1hgtuOzY=",
    "cpf": "U2FsdGVkX181NM27bYpc0JJA4y9Qx8hS96mJfXC6TYM="
  },
  {
    "num_cand": "U2FsdGVkX18LA1TmVrq73zzJA+HPPSIKTMtUdecv0Sw=",
    "cpf": "U2FsdGVkX19ICusMOsx8niTHWRB5WS2N/SeLEfxUSuQ="
  },
  {
    "num_cand": "U2FsdGVkX1+OS1qGasVhW79gwHjk3KBOdMHVB3FEnzY=",
    "cpf": "U2FsdGVkX1+SdY3JuINFk8/wOA47nFn6UK0zshf5mZ8="
  }
]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2202/2202_rec_gabs/${nome_arquivo}`)
            return window.location.replace(url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
